/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import loadingConfig from "./config/loading.config.json";

const is = require("is_js");

const SERVICE_NAME = "DistCenterDetailsPageService";
const log: any = LoggerModule.getInstance();

export class DistCenterDetailsPageService {
  private static instance: DistCenterDetailsPageService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): DistCenterDetailsPageService {
    if (!DistCenterDetailsPageService.instance) {
      DistCenterDetailsPageService.instance = new DistCenterDetailsPageService(
        props
      );
    }
    return DistCenterDetailsPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    // if (args?.criteria) {
    //   this.setCriteria(args?.criteria);
    // }

    compProps = await agent.getDistCenterDetails({
      // ...args,
      // criteria: { ...this.criteria, ...args?.criteria },
    });

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateDistCenter(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateDistCenter(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async createDistCounter(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.createDistCounter(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }
}
